module.exports = __webpack_public_path__ + "img/problem_blockage.e78a48ba.svg";